import { useLocation, useNavigationType } from '@remix-run/react'
import { useEffect } from 'react'
import {
  aDrawMode,
  aDrawnFeature,
  aMapDrawIsOpen,
  useAtomValue,
  useSetAtom,
} from '~/atoms'
import {
  clearRememberedDrawnFeatureForBackNavigation,
  getRememberedDrawnFeatureForBackNavigation,
  rememberDrawnFeatureForBackNavigation,
} from './drawnFeatureBackNavigation'

export function useDrawnFeatureBackNavigationRestore() {
  const location = useLocation()
  const navigationType = useNavigationType()
  const drawnFeature = useAtomValue(aDrawnFeature)
  const setDrawnFeature = useSetAtom(aDrawnFeature)
  const setDrawMode = useSetAtom(aDrawMode)
  const setIsDrawOpen = useSetAtom(aMapDrawIsOpen)

  useEffect(() => {
    if (!drawnFeature) return

    rememberDrawnFeatureForBackNavigation(drawnFeature)
  }, [drawnFeature])

  useEffect(() => {
    if (navigationType === 'POP' || drawnFeature) return

    clearRememberedDrawnFeatureForBackNavigation()
  }, [drawnFeature, navigationType])

  useEffect(() => {
    if (navigationType !== 'POP') return

    const rememberedFeature = getRememberedDrawnFeatureForBackNavigation()

    if (!rememberedFeature) return

    setDrawnFeature(rememberedFeature)
    setDrawMode(null)
    setIsDrawOpen(true)
  }, [location.key, navigationType, setDrawMode, setDrawnFeature, setIsDrawOpen])
}
